import React from "react";
import RingotelUserForm from "../Form/RingotelUser";
import ModalWrapper from "../generic/modal";
const AddRingotelUser = ({
  setIsModalOpen,
  isModalOpen,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
}) => {
  return (
    <ModalWrapper
      title="Add Ringotel User"
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    >
      <RingotelUserForm editData={null} setIsModal={setIsModalOpen} />
    </ModalWrapper>
  );
};

export default AddRingotelUser;
